import { logFeature } from '@office-start/telemetry-service';
/**
 * Used to log params received from Hub SDK
 * @param params object type AppHostInstrumentationParams
 */
export var logMosHubFeature = function (params) {
    var _a, _b, _c;
    logFeature({
        featureName: "MOSHub" /* KnownFeatureNames.MOSHub */,
        eventName: "MOS_Hub_SDK_Request" /* KnownFeatureInstrumentationEvents.MOSHubSDK */,
        params: {
            AppHostSessionId: params.appHostSessionId,
            AppId: params.appId,
            Error: (_a = params.error) !== null && _a !== void 0 ? _a : '',
            ClientTimeStamp: (_b = params.clientTimestamp) !== null && _b !== void 0 ? _b : 0,
            FrameContext: params.frameContext,
            MessageDelayMs: (_c = params.messageDelayMs) !== null && _c !== void 0 ? _c : 0,
            MOSHubScenarioName: params.scenarioName,
        },
        area: 'MOSAppHost',
        subArea: params.scenarioName,
    });
};
//# sourceMappingURL=logMosHubFeature.js.map